module.exports = __webpack_public_path__ + "img/al04l-s7nmp.4d508fe0.png";